import { WhoAmIResponse } from '../types/auth';
import { swrCache } from './swrCache';

class AuthService {
  async getWhoAmI(): Promise<WhoAmIResponse> {
    try {
      const response = await fetch('/_whoami');
      if (!response.ok) {
        throw new Error(`Error fetching user identity: ${response.statusText}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Failed to get whoami response:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    // Drop the cached game data (player profiles, session streams) from this browser first; best
    // effort, bounded so a wedged IndexedDB cannot hold up the logout.
    await Promise.race([swrCache.clear(), new Promise((resolve) => setTimeout(resolve, 1500))]).catch(() => undefined);
    window.location.href = 'https://playcdu.cloudflareaccess.com/cdn-cgi/access/logout';
  }
}

export const authService = new AuthService();
